<template>
  <div class="msg-detail" >
    <navigation sticky>消息详情</navigation>
    <div class="content">
      <iframe
        ref="authIframe"
        class="iframe"
        :src="authenticationProtocol"
        frameborder="0"
      ></iframe>
    </div>

  </div>
</template>

<script>
import Auth from './components/auth.vue'
import { mapActions } from 'vuex'
import axios from '@/assets/axios'
export default {
  components: {
    Auth
  },
  data () {
    return {
      detail: {},
      authenticationProtocol: '',
      showPage: false
    } 
  },

  mounted () {
    this.getDetail()
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('message', ['messageDetail', 'messageRead']),
    read () {
      this.messageRead({
        recordNo: this.$route.query.recordNo
      })
    },
    async getDetail () {
      const { success, data } = await this.messageDetail({
        recordNo: this.$route.query.recordNo
      })
      if (success) {
        this.detail = data
        const origin = process.env.VUE_APP_PROURL
        const res = await axios.get(`/letter/getLetterUrlByAccessCode?a=${data.content?.url}`, {
          notNeedBaseURL: true
        })
        if (res.data.code === '000000') {
          this.authenticationProtocol = `${origin}/protocol/src2pdf?file=${res.data.data}&hideNav=Y`
        } else {
          this.$router.replace('/landing/intercept')
        }
       
        this.showPage = true
        if (this.detail.read === 'N') {
          this.read()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.msg-detail {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .auth-dialog {
    .dialog-content {
      padding: 0 45px;
      padding-bottom: 40px;
      position: relative;
    }

    .title {
      font-size: 42px;
      height: 72px;
      line-height: 72px;
      font-family: PingFangSC-Semibold,PingFang SC;
      font-weight: 600;
    }
    .tip {
        font-size: 28px;
        line-height: 40px;
        margin-top: 37px;
        font-family: PingFangSC-Regular,PingFang SC;
        font-weight: 400;
        color: #999;
    }
    .confirm-btn {
      margin: 40px auto 0;
      display: block;
    }

  }
  .content {
    flex: 1;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
    border-top: 20px solid #fafafa;
    iframe {
      width: 100%;
      height: 100%;
      border: none;
    }
  }
}
.footer {
  display: flex;
  bottom: 0;
  height: 180px;
  background: #ffffff;
  box-shadow: 0 -1px 3px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
}
</style>